import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=2b31491a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b31491a')) {
      api.createRecord('2b31491a', component.options)
    } else {
      api.reload('2b31491a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=2b31491a&", function () {
      api.rerender('2b31491a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UBWIJf46EtDs/JS/imageCarousel.vue"
export default component.exports